import { SubscriptionPlanType } from '@/types/subscription'

export function isFreePlan(planType?: SubscriptionPlanType): boolean {
  return !planType || planType === SubscriptionPlanType.Free
}

export function isFreeOrProPlan(planType?: SubscriptionPlanType): boolean {
  return (
    !planType ||
    [SubscriptionPlanType.Free, SubscriptionPlanType.Pro].includes(planType)
  )
}
